import request from "@/utils/clientRequest";

const scope = '';


// 获取首页数据
export function showStudentInfoInH5(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/showStudentInfoInH5",
        method: "post",
        data: query
    });
}

// 写留言
export function leaveMessage(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/leaveMessage",
        method: "post",
        data: query
    });
}

// 查询留言
export function pageLeaveMessage(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/pageLeaveMessage",
        method: "post",
        data: query
    });
}

// 新增亲情号码
export function addRelations(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/addRelations",
        method: "post",
        data: query
    });
}

// 删除亲情号码
export function removeRelations(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/removeRelations",
        method: "post",
        data: query
    });
}

// 显示亲情号码
export function showRelationList(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/showRelationList",
        method: "post",
        data: query
    });
}

// 围栏列表
export function listElectricFence(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/listElectricFence",
        method: "post",
        data: query
    });
}

// 围栏设置
export function editElectricFence(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/editElectricFence",
        method: "post",
        data: query
    });
}

// 通话清单
export function listCallRecord(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/listCallRecord",
        method: "post",
        data: query
    });
}

// 定位模式
export function setLocationModel(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/setLocationModel",
        method: "post",
        data: query
    });
}

// 远程控制
export function remoteControl(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/remoteControl",
        method: "post",
        data: query
    });
}

// 轨迹数据
export function getStudentTrajectory(query) {
    return request({
        url: scope + "/exueyun-client-consumer/clientStudentCardH5/getStudentTrajectory",
        method: "post",
        data: query
    });
}

//获取指定学生的白名单学校班级
//http://127.0.0.1:8050/exueyun-client-consumer/client/healthCode/listSchoolWhiteByStudentName
export function listSchoolWhiteByStudentName(query) {
    return request({
        url: scope + "/exueyun-client-consumer/client/healthCode/listSchoolWhiteByStudentName",
        method: "post",
        data: query
    })
}

//开通健康码
//http://127.0.0.1:8050/exueyun-client-consumer/client/healthCode/open
export function openHealthCode(query) {
    return request({
        url: scope + "/exueyun-client-consumer/client/healthCode/open",
        method: "post",
        data: query
    })
}